var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79595 5.00009L9.33509 1.46081C9.55497 1.2411 9.55497 0.884623 9.33509 0.664919C9.1152 0.445027 8.75911 0.445027 8.53923 0.664919L5.00009 4.2042L1.46077 0.664919C1.24089 0.445027 0.884795 0.445027 0.664912 0.664919C0.445029 0.884623 0.445029 1.2411 0.664912 1.46081L4.20424 5.00009L0.664912 8.53938C0.445029 8.75908 0.445029 9.11556 0.664912 9.33527C0.774854 9.44503 0.918941 9.5 1.06284 9.5C1.20674 9.5 1.35083 9.44503 1.46077 9.33508L5.00009 5.79579L8.53923 9.33508C8.64917 9.44503 8.79326 9.5 8.93716 9.5C9.08106 9.5 9.22515 9.44503 9.33509 9.33508C9.55497 9.11538 9.55497 8.7589 9.33509 8.53919L5.79595 5.00009Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.81c8e8e5dc24a6a9c5feab7f42e58f2d.svg";
export { ForwardRef as ReactComponent };